
export default {
  PROS: '#c7588f',
  'PC do B': '#a65062',
  MDB: '#b1640c',
  PSB: '#e6b300',
  PRB: '#edcdab',
  PTB: '#70b7e7',
  PSOL: '#f7df00',
  PT: '#cb613f',
  REDE: '#769887',
  PSL: '#cdcf7d',
  PODE: '#98bc70',
  PDT: '#958476',
  PPS: '#8b79af',
  PP: '#c8bf70',
  DEM: '#4b8196',
  PHS: '#a2b090',
  PSDB: '#1b5595',
  PMB: '#697aa2',
  AVANTE: '#88aeb7',
  PSC: '#008B4B',
  PPL: '#aeaeb3',
  PR: '#cea45c',
  DC: '#597037',
  PRP: '#d4d721',
  PV: '#7a9632',
  SOLIDARIEDADE: '#deb37d',
  PTC: '#e0ddb6',
  PRTB: '#a891bd',
  PMN: '#8cc1ce',
  PSD: '#0087ca',
  PATRI: '#7eaa64',
  PSTU: '#d3807f',
  NOVO: '#d88d19',
  PCO: '#5b5a5d',
  PCB: '#a45524',
  BRANCO: '#9b9b9b',
  NULO: '#424242',
};



// WEBPACK FOOTER //
// ./src/helpers/partidos.js